import { createContext } from 'react'

export interface IAnalyticContext {
  register: (name: string) => void
  sendAnalytics: (name: string) => void
}

export const AnalyticContext = createContext<IAnalyticContext>({
  register: () => undefined,
  sendAnalytics: () => undefined,
})
